// import Chip from '@mui/material/Chip'
import { Badge, Chip } from '@mui/material';
import React from 'react';

interface RateUsageCounterProps {
  assetRatedStatus: string
  ratedCount: number
}

const RatedUsageCounterChip = (props: RateUsageCounterProps) => {
  // AssetRatedUsageStatus.PENDING | AssetRatedUsageStatus.CONFIRMED | AssetRatedUsageStatus.CANCELLED
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (props.assetRatedStatus === 'CANCELLED') {
    color = 'error'
    variant = 'outlined'
  } else if (props.assetRatedStatus === 'PENDING') {
    color = 'warning'
    variant = 'outlined'
  } else if (props.assetRatedStatus === 'CONFIRMED') {
    color = 'success'
    variant = 'outlined'
  } else {
    color = 'secondary'
    variant = 'outlined'
  }

  return (
    <Badge badgeContent={props.ratedCount} color={color}>
      <Chip label={props.assetRatedStatus} variant={variant} color={color} />
    </Badge>
  )
}

export default RatedUsageCounterChip;
